export const MSK_TIMEZONE = 'Europe/Moscow'

const mskDateKeyFormatter = new Intl.DateTimeFormat('en-CA', {
  timeZone: MSK_TIMEZONE,
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
})

export function getMskDateKey(date) {
  const value = date instanceof Date ? date : new Date(date)

  return mskDateKeyFormatter.format(value)
}

export function parseDateKey(dateKey) {
  const [year, month, day] = dateKey.split('-').map(Number)

  return { year, month: month - 1, day }
}

export function formatDateKey(year, month, day) {
  return `${year}-${String(month + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`
}

export function addDaysToDateKey(dateKey, days) {
  const { year, month, day } = parseDateKey(dateKey)
  const date = new Date(Date.UTC(year, month, day))

  date.setUTCDate(date.getUTCDate() + days)

  return formatDateKey(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate())
}

export function getMskTodayParts() {
  return parseDateKey(getMskDateKey(new Date()))
}

export function buildEventsByMskDate(eventsList) {
  const eventsByDate = {}

  for (const event of eventsList) {
    let dateKey = getMskDateKey(event.start_date)
    const endDateKey = getMskDateKey(event.end_date)

    while (dateKey <= endDateKey) {
      if (!eventsByDate[dateKey]) {
        eventsByDate[dateKey] = []
      }

      eventsByDate[dateKey].push(event)
      dateKey = addDaysToDateKey(dateKey, 1)
    }
  }

  return eventsByDate
}
